/* eslint-disable import/no-anonymous-default-export */
const monitoringState = {
    isLoading: false,
    isError: false,
    isGet: false,
    alertMsg: '',
    dataMonitoring: [],
    page: {}
};

export default (state=monitoringState, action) => {
    switch(action.type){
        case 'GET_MONITORING_TRANSAKSI_PENDING': {
            return {
                ...state,
                isLoading: true,
                isError: false,
                alertMsg: 'Waiting ...'
            };
        }
        case 'GET_MONITORING_TRANSAKSI_FULFILLED': {
            return {
                ...state,
                isLoading: false,
                isGet: true,
                dataMonitoring: action.payload.data.result,
                page: action.payload.data.pageInfo,
                alertMsg: 'get monitoring transaksi succesfully'
            };
        }
        case 'GET_MONITORING_TRANSAKSI_REJECTED': {
            return {
                ...state,
                isLoading: false,
                isGet: false,
                isError: true,
                alertMsg: "Unable connect to server"
            };
        }
        default: {
            return state;
        }
    }
}
